import React, { useMemo, useContext, useEffect, useState, useRef } from 'react'
import { buildCtaStyleMap } from './ProductOptionCTA'
import Spinner from '../../components/Spinner'
import { useIsDesktop, useWindowDimensions } from '../../services/UtilityService'
import { PDP_PRODUCT_OPTIONS_ID } from '../../constants/PDPConstants'
import { Translations } from '../../services/TranslationService'
import { StateContext } from '../../services/StateService'
import useProductOptionsColumns from '../../hooks/useProductOptionsColumns'
import useProductOptionsData from '../../hooks/useProductOptionsData'
import ProductOptionsMobile from './ProductOptionsMobile'
import ProductOptionsDesktop from './ProductOptionsDesktop'
import '../../css/ProductOptions.scss'

const ProductOptions = () => {
    const isDesktop = useIsDesktop()
    const { windowWidth } = useWindowDimensions()
    const translations = useContext(Translations)
    const ref = useRef()
    const [tableHeight, setTableHeight] = useState(0)

    useEffect(() => {
        setTableHeight(ref.current?.clientHeight)
    }, [ref?.current?.clientHeight])

    const {
        moreOptions: { options },
        productOptions,
        loadingProductOptions: { loading, isUpdate },
        selectedOptions
    } = useContext(StateContext)

    const ctaStyleMap = useMemo(() => buildCtaStyleMap(productOptions), [productOptions])

    const { columnIdentifiers, desktopCols } = useProductOptionsColumns({
        options,
        selectedOptions,
        productOptions,
        ctaStyleMap,
        translations,
        isDesktop
    })

    const { desktopData } = useProductOptionsData({
        productOptions,
        columnIdentifiers,
        isDesktop
    })

    return (
        <div
            className="sps2-pdp_product-options"
            tabIndex="-1"
            id={PDP_PRODUCT_OPTIONS_ID}
        >
            {loading && !isUpdate && (
                <div
                    className="sps2-pdp_product-options--loader"
                    style={{ height: tableHeight }}
                >
                    <Spinner />
                </div>
            )}
            {isDesktop && desktopData.length > 0 && desktopCols.length > 0 && (
                <ProductOptionsDesktop
                    desktopCols={desktopCols}
                    desktopData={desktopData}
                    windowWidth={windowWidth}
                    tableHeight={tableHeight}
                    tableRef={ref}
                />
            )}
            {!isDesktop > 0 && columnIdentifiers.length && productOptions?.length > 0 && (
                <ProductOptionsMobile
                    columnIdentifiers={columnIdentifiers}
                    ctaStyleMap={ctaStyleMap}
                />
            )}
        </div>
    )
}

export default ProductOptions
